'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { FaXmark } from 'react-icons/fa6';
import { setCookieAppBannerHide } from '@/features/roomster-app/cookies/cookie-app-banner-hide';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import styles from './app-banner.module.scss';
interface AppBannerProps {
  isBannerClosed: boolean;
  setIsBannerClosed: (isClosed: boolean) => void;
}
export default function AppBanner(props) {
  const $ = _c(10);
  const {
    isBannerClosed,
    setIsBannerClosed
  } = props;
  const translationsAppBanner = useTranslations("roomster-app.app-banner");
  const appFlyerLink = useAppFlyerLink("mobile", "mobileTopBanner");
  let t0;
  if ($[0] !== setIsBannerClosed) {
    t0 = () => {
      setIsBannerClosed(true);
      setCookieAppBannerHide(true);
    };
    $[0] = setIsBannerClosed;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleCloseBanner = t0;
  let t1;
  if ($[2] !== handleCloseBanner) {
    t1 = () => {
      handleCloseBanner();
    };
    $[2] = handleCloseBanner;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleGetAppClick = t1;
  let t2;
  if ($[4] !== appFlyerLink || $[5] !== handleCloseBanner || $[6] !== handleGetAppClick || $[7] !== isBannerClosed || $[8] !== translationsAppBanner) {
    t2 = !isBannerClosed && <div id="app-banner" className={styles.appBanner}><div className={styles.appBanner_container}><div className={styles.appBanner_content}><button className={styles.appBanner_close} onClick={handleCloseBanner} aria-label="close"><FaXmark className={styles.appBanner_closeIcon} /></button><a className={styles.appBanner_content} onKeyUp={handleGetAppClick} href={appFlyerLink} rel="noreferrer"><div className={styles.banner_logo}><Image src="/images/roomster-logo/logo-white.svg" width={28} height={28} alt="roomster logo" /></div><div className={styles.appBanner_info}><p className={styles.banner_title}>{translationsAppBanner("title")}</p><p className={styles.banner_text}>{translationsAppBanner("text")}</p></div><div className={styles.appBanner_button}>{translationsAppBanner("button")}</div></a></div></div></div>;
    $[4] = appFlyerLink;
    $[5] = handleCloseBanner;
    $[6] = handleGetAppClick;
    $[7] = isBannerClosed;
    $[8] = translationsAppBanner;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}